module.exports = __webpack_public_path__ + "static/media/logoimg.f604b9aa.png";